import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { SeFeButtonModule } from 'se-fe-button'
import { SeFeIconModule, seFeIconSpotJersey } from 'se-fe-icon'
import { SeFeSpinnerModule } from 'se-fe-spinner'
import { SharedUiChildContactInfoModule } from '@se-po/shared-ui-child-contact-info'
import { SharedUiHighlightLabelModule } from '@se-po/shared-ui-highlight-label'

import { ChildContactInfoComponent } from './child-contact-info/child-contact-info.component'
import { SharedUiAddChildContactInfoModule } from '@se-po/shared-ui-add-child-contact-info'

@NgModule({
  declarations: [ChildContactInfoComponent],
  exports: [ChildContactInfoComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SeFeButtonModule,
    SeFeIconModule.include([seFeIconSpotJersey]),
    SeFeSpinnerModule,
    SharedUiAddChildContactInfoModule,
  ],
})
export class SeHouseholdSetupFeatureChildContactInfoModule { }
